// extracted by css-extract-rspack-plugin
export default {"title":"src-Title-title-e4771298"};